import React  from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Avatar } from 'antd';
import ruRU from 'antd/es/locale/ru_RU';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { ReactComponent as Exit } from '../../images/exit.svg';
import { BASE } from 'api';

const UserInfo = styled.div`
  &&& {
    width: 84px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .anticon-export {
      font-size: 21px;
    }
  }
`;

function UserLogOut() {
  const avatar = useSelector((state) =>
    get(state, `fetch.language.dataSource.avatar`, null),
  );

  const logOut = () => {
    localStorage.removeItem('access_token');
    document.location.reload(true);
  };

  return (
    <UserInfo>
      <Link to="/profile">
        {avatar ? (
          <Avatar
            src={`${BASE}${avatar}`}
            style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
            className={
              window.location.href.indexOf('profile') > 1
                ? 'border-2 border-linkLine'
                : null
            }
          >
            U
          </Avatar>
        ) : null}
      </Link>
      <Exit
        className="cursor-pointer"
        onClick={() => {
          logOut();
        }}
      />
    </UserInfo>
  );
}

UserLogOut.propTypes = {};

export default UserLogOut;
